import { Card, Slide } from '@material-ui/core';
import React, { Fragment } from 'react';
import './MyRides.css';
import { Virtuoso } from 'react-virtuoso';
import moment from 'moment';
import { AppEnum } from '../../../common/AppEnum';

const MyRides = (props) => {

    const { labelList, rideList } = props.state;

    return (
        <Fragment>
            <div className='ride-main-div'>
                <Card className='M-ui-card'>
                    <Slide direction="right" timeout={500} in={true} mountOnEnter unmountOnExit>
                        <div>
                            <div>
                                <label className='profile-label'>{labelList.filter(i => i.key === 'Menu.MyRides')[0]?.value}</label>
                                <hr className='ride-shipment-hr' />
                            </div>
                            <div className='shipment-div'>
                                <table>
                                    {
                                        rideList?.length !== 0 &&
                                        <tr className='menu-column-row scrollbar-width'>
                                            <td>{labelList.filter(i => i.key === 'Menu.Date')[0]?.value}</td>
                                            <td>{labelList.filter(i => i.key === 'Menu.Distance')[0]?.value}</td>
                                            <td>{labelList.filter(i => i.key === 'Menu.Duration')[0]?.value}</td>
                                            <td>{labelList.filter(i => i.key === 'Menu.cost')[0]?.value}</td>
                                            <td>{labelList.filter(i => i.key === 'Menu.Status')[0]?.value}</td>
                                        </tr>
                                    }
                                    <tr>
                                        <Virtuoso
                                            style={{ height: '40vh' }}
                                            data={rideList}
                                            endReached={props.fetchNextRideList}
                                            itemContent={(index, ride) => {
                                                return (
                                                    <tr key={index} id={index} className={index % 2 ? 'menu-column-row' : 'menu-column-row-odd'}>
                                                        <td>{moment.utc(ride.orderDate).local().format('DD/MM/YYYY')}</td>
                                                        <td>{Math.round((ride.arrivalDistanceInKm + Number.EPSILON) * 100) / 100} km</td>
                                                        <td>{Math.round((ride.arrivalTimeInMin + Number.EPSILON) * 100) / 100} min</td>
                                                        <td>{ride.currencyCode === AppEnum.CurrencyCode.Indian ? <i className="fas fa-rupee-sign"></i>
                                                            : <i className="fas fa-dollar-sign doller-icon"></i>} {Math.round((ride.totalAmount + Number.EPSILON) * 100) / 100}</td>
                                                        <td>{ride.orderStatus}</td>
                                                    </tr>
                                                )
                                            }}
                                            components={{
                                                Footer: () => {
                                                    return (
                                                        <div>
                                                            {
                                                                rideList?.length === 0 &&
                                                                <div>
                                                                    <span className='no-records'>{labelList.filter(i => i.key === 'Validation.NoRecords')[0]?.value}</span>
                                                                </div>
                                                            }
                                                        </div>
                                                    )
                                                }
                                            }}
                                        />
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </Slide >
                </Card>
            </div>
        </Fragment>
    )
}

export default MyRides;